import { render, staticRenderFns } from "./RolesIndexComponent.vue?vue&type=template&id=0040b2d4&scoped=true"
import script from "./RolesIndexComponent.vue?vue&type=script&lang=js"
export * from "./RolesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040b2d4",
  null
  
)

export default component.exports